import * as types from '../constants/ActionTypes';

export const setAutorizacionTrabajoMenor = autorizacion => dispatch => {
  dispatch({
    type: types.SET_AUTORIZACION_TRABAJO_MENOR,
    payload: {
      autorizacion,
    },
  });
};
